import http from '@/http'
import requestUrlFunction from '@/utils/requestUrl'

export default {
  namespaced: true,
  actions: {
    async searchUsers(context, { params, roles }) {
      const response = await http.get(
        `user/${requestUrlFunction(params)}` + `&roles=${roles.join('&roles=')}`
      )

      return response
    },
    async getUser(context, id) {
      const response = await http.get(`user/${id}`)

      return response
    },
    async createUser(context, user) {
      const response = await http.post(`user/`, {
        email: user.email,
      })

      return response
    },
    async updateUser(context, user) {
      const response = await http.put(`user/${user.id}`, {
        email: user.email,
      })

      return response
    },
    async deleteUser(context, id) {
      const response = await http.delete(`user/${id}`)

      return response
    },
    async passwordReset(context, form) {
      const response = await http.get(`user/password-reset?email=${form.email}`)

      return response
    },
    async passwordResetConfirm(context, { code, password }) {
      const response = await http.post('user/password-reset/confirm', {
        code: code,
        password: password,
      })

      return response
    },
    async passwordSetupConfirm(context, { code, password }) {
      const response = await http.post(`user/password-setup/confirm`, {
        code: code,
        password: password,
      })

      return response
    },
  },
}
